/* tslint:disable */
/* eslint-disable */
/**
 * esign
 * eSign template authoring and request management service
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const CompletedDocumentLinkRecipientType = {
    Signer: 'signer',
    Additional: 'additional',
} as const;
export type CompletedDocumentLinkRecipientType = typeof CompletedDocumentLinkRecipientType[keyof typeof CompletedDocumentLinkRecipientType];


export function instanceOfCompletedDocumentLinkRecipientType(value: any): boolean {
    for (const key in CompletedDocumentLinkRecipientType) {
        if (Object.prototype.hasOwnProperty.call(CompletedDocumentLinkRecipientType, key)) {
            if (CompletedDocumentLinkRecipientType[key as keyof typeof CompletedDocumentLinkRecipientType] === value) {
                return true;
            }
        }
    }
    return false;
}

export function CompletedDocumentLinkRecipientTypeFromJSON(json: any): CompletedDocumentLinkRecipientType {
    return CompletedDocumentLinkRecipientTypeFromJSONTyped(json, false);
}

export function CompletedDocumentLinkRecipientTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): CompletedDocumentLinkRecipientType {
    return json as CompletedDocumentLinkRecipientType;
}

export function CompletedDocumentLinkRecipientTypeToJSON(value?: CompletedDocumentLinkRecipientType | null): any {
    return value as any;
}

export function CompletedDocumentLinkRecipientTypeToJSONTyped(value: any, ignoreDiscriminator: boolean): CompletedDocumentLinkRecipientType {
    return value as CompletedDocumentLinkRecipientType;
}

